import { get } from "lodash";
import moment from "moment";

export const stringSorter = (path) => (a, b) => {
  const valA = (get(a, path) || "").toString().toLowerCase();
  const valB = (get(b, path) || "").toString().toLowerCase();
  return valA.localeCompare(valB);
};

export const numberSorter = (path) => (a, b) => {
  const valA = Number(get(a, path)) || 0;
  const valB = Number(get(b, path)) || 0;
  return valA - valB;
};

export const dateSorter = (path) => (a, b) => {
  const aDate = moment(get(a, path));
  const bDate = moment(get(b, path));

  return aDate.diff(bDate);
};
